/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { AbstractControl, AbstractControlOptions, FormControlStatus, FormGroup, ValidationErrors } from '@angular/forms';
import { createNgfControlEnhancement } from '@ng-falcon/ngf-form/+model/enhancement/ngf-control-enhancement';
import { Observable } from 'rxjs';

export type NgfFormGroupOptions = AbstractControlOptions & { disabled?: boolean; }

export class NgfFormGroup<T extends { [K in keyof T]: AbstractControl }> extends FormGroup<T> {
  readonly value$: Observable<FormGroup<T>['value']>;
  readonly errors$: Observable<ValidationErrors | null>;
  readonly touched$: Observable<boolean>;
  readonly untouched$: Observable<boolean>;
  readonly pristine$: Observable<boolean>;
  readonly dirty$: Observable<boolean>;
  readonly status$: Observable<FormControlStatus>;
  readonly valid$: Observable<boolean>;
  readonly invalid$: Observable<boolean>;
  readonly pending$: Observable<boolean>;
  readonly enabled$: Observable<boolean>;
  readonly disabled$: Observable<boolean>;

  constructor(controls: T, opts?: NgfFormGroupOptions) {
    super(controls, opts);

    const ngfControlEnhancement = createNgfControlEnhancement(this);
    this.value$ = ngfControlEnhancement.value$;
    this.errors$ = ngfControlEnhancement.errors$;
    this.touched$ = ngfControlEnhancement.touched$;
    this.untouched$ = ngfControlEnhancement.untouched$;
    this.pristine$ = ngfControlEnhancement.pristine$;
    this.dirty$ = ngfControlEnhancement.dirty$;
    this.status$ = ngfControlEnhancement.status$;
    this.valid$ = ngfControlEnhancement.valid$;
    this.invalid$ = ngfControlEnhancement.invalid$;
    this.pending$ = ngfControlEnhancement.pending$;
    this.enabled$ = ngfControlEnhancement.enabled$;
    this.disabled$ = ngfControlEnhancement.disabled$;

    if (opts?.disabled) {
      this.disable();
    }
  }

}

